export default "__VITE_ASSET__Gj_D9$T$__"